var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCatalog = function SvgCatalog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 41,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.691 40.232a.805.805 0 0 1-.804-.804V2.6c0-.444.36-.804.804-.804h32.897c.444 0 .804.36.804.804v36.827c0 .444-.36.804-.804.804H4.69Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.6,
    d: "M11.048 40.232V1.796M14.301 27.333h20.604M14.301 33.22h20.604"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.86 1.79h3.759c.813 0 1.472.658 1.472 1.471v35.5c0 .813-.66 1.472-1.472 1.472H5.366a1.472 1.472 0 0 1-1.471-1.471v-35.5c0-.814.658-1.473 1.471-1.473h19.85",
    stroke: "#000",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.265 30.845a1.91 1.91 0 1 1 0-3.82h2.202a1.91 1.91 0 0 1 0 3.82H3.265ZM3.262 22.412a1.908 1.908 0 1 1 0-3.815H5.47a1.908 1.908 0 0 1 0 3.815H3.262ZM3.262 13.124a1.908 1.908 0 1 1 0-3.815H5.47a1.908 1.908 0 0 1 0 3.815H3.262Z",
    fill: "#D9D9D9",
    stroke: "#000",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.86 13.547c0-.088.042-.17.114-.22l5.07-3.523a.267.267 0 0 1 .304 0l5.07 3.524c.072.05.115.131.115.219v7.81c0 .146-.12.266-.267.266h-10.14a.267.267 0 0 1-.267-.267v-7.81Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.848 14.066v7.128c0 .304.247.551.551.551h9.549a.552.552 0 0 0 .551-.551v-7.519a.551.551 0 0 0-.238-.454l-4.71-3.26a.552.552 0 0 0-.623-.004l-4.837 3.265a.552.552 0 0 0-.243.457v.17",
    stroke: "#000",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.757 13.29a.305.305 0 0 1 .06-.444l7.156-4.983a.337.337 0 0 1 .388.001l6.992 4.97c.155.11.188.326.074.478l-.964 1.279a.337.337 0 0 1-.467.07l-5.637-4.066a.337.337 0 0 0-.387-.006l-5.799 3.94a.337.337 0 0 1-.45-.064l-.966-1.175Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.12 9.9 2.731-1.912a.552.552 0 0 1 .633 0l6.813 4.769a.552.552 0 0 1 .107.805l-.81.972a.552.552 0 0 1-.747.093l-5.36-3.886a.552.552 0 0 0-.642-.003l-5.488 3.882a.551.551 0 0 1-.76-.12l-.708-.943a.551.551 0 0 1 .125-.783l2.581-1.807",
    stroke: "#000",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.013 16.986h-3.718a.276.276 0 0 0-.276.276v4.486h4.27v-4.486a.276.276 0 0 0-.276-.276Z",
    fill: "#E6F7FE",
    stroke: "#000",
    strokeWidth: 0.6
  })));
};
export default SvgCatalog;